import { render, staticRenderFns } from "./instalaciones.vue?vue&type=template&id=de521cee&"
import script from "./instalaciones.vue?vue&type=script&lang=js&"
export * from "./instalaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports